import { phpRequest } from "./phpRequest";

export const createCompanyRoleAPI = (role_name, company_id, permissions) => {
  return phpRequest.post("/roles/create", {
    role_name,
    permissions,
    company_id,
  });
};
